import React, {Component} from 'react';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import classNames from 'classnames';
import ReactHover from 'react-hover-observer';
import { Link } from '@reach/router';
import Image from '../Image';
import { RichText } from 'prismic-reactjs';
import { Carousel } from 'react-responsive-carousel';
import ArrowRight from './Arrow/ArrowRight';
import ArrowLeft from './Arrow/ArrowLeft';

import "./carousel.css";
import './Project.css';


class Project extends Component{

  constructor(props){
    super(props);
    this.state = { currentIndex: 0, length: null, infoOpen: false, isZoomed: false, lazyloaded: false }
    this.projectRef = React.createRef();
    this.onClickItem = this.onClickItem.bind(this);
    this.onClickInfo = this.onClickInfo.bind(this);
    this.onClickNext = this.onClickNext.bind(this);
    this.onClickPrev = this.onClickPrev.bind(this);
  }

  componentDidMount(){
    let length = this.props.images.length;
    this.setState({length});
  }

  componentWillUnmount(){
    clearAllBodyScrollLocks();
  }

  onClickItem(){
    this.setState({infoOpen: false});
    if(this.props.width <= 500){

      if(this.state.isZoomed){
        this.setState({isZoomed: false})
        enableBodyScroll(this.projectRef.current);
        let {updateProject, id} = this.props;
        let {currentIndex} = this.state;
        updateProject(id,currentIndex)
      }
      else{
        this.setState({isZoomed: true})
        disableBodyScroll(this.projectRef.current);
      }
    }
    else {
      let {toggleProject, id} = this.props;
      let {currentIndex} = this.state;
      toggleProject(id, currentIndex);
    }
  }

  onClickInfo(){
    this.setState(prevState => ({
      infoOpen: !prevState.infoOpen
    }));
  }

  onClickPrev(){
    let currentIndex = this.state.currentIndex - 1;
    currentIndex < 0 && (currentIndex = this.state.length - 1);
    this.setState({currentIndex});
  }

  onClickNext(){
    let currentIndex = this.state.currentIndex + 1;
    currentIndex >= this.state.length && (currentIndex = 0);
    this.setState({currentIndex});
  }

  renderImages(images){
    return images.map(({url, alt, format, retina}, index)=> {
      if(index === this.state.currentIndex || this.props.isOpen || this.state.isZoomed){
        return(
          <Image key={url} alt={alt} src={url} format={format} retina={retina}/>
        )
      }
      return null;
    })
  }

  render(){
    let {currentIndex, infoOpen, isZoomed} = this.state;
      let {title, images, text, isOpen, id, slug} = this.props;
    let slideLength = images.length;

    let ProjectContainerClass = classNames('Project-container', {
      'Project-container-open-mobil': isZoomed,
    });

    let ProjectClass = classNames('Project', {
      'Project-open': isOpen,
    });

    let informationClass = classNames('Project-information', {
      'Project-information-activ': infoOpen,
    });


    return (
      <div id={id} className={ProjectContainerClass}>
        <div ref={this.projectRef} className={ProjectClass}>
          <div className="Project-inner-container">
                     <div className="Project-header">
              <div className="Project-header-left">
                <div className="Project-header-title">{RichText.asText(title)}</div>
                { (isOpen || isZoomed ) && <div className="Project-header-status">{`${currentIndex +1}/${slideLength}`}</div> }
              </div>
              <div className="Project-header-right">
                { (isOpen || isZoomed ) && (
                  <Link to={`/project/${slug}`} className="Project-header-info">
                    Information
                  </Link>
                )}
              </div>
            </div>
            <div onClick={this.onClickItem} className={informationClass}>
              <div className="Project-text">{RichText.render(text)} </div>
            </div>
            { (isOpen || isZoomed ) && (
              <React.Fragment>
                <ReactHover>
                {({ isHovering }) => (
                  <div onClick={this.onClickPrev} className="Project-control-prev">
                    <ArrowLeft hover={isHovering} />
                  </div>
                )}
                </ReactHover>
                <ReactHover>
                {({ isHovering }) => (
                  <div onClick={this.onClickNext} className="Project-control-next">
                    <ArrowRight hover={isHovering} />
                  </div>
                )}
                </ReactHover>
              </React.Fragment>
            )}
            <Carousel
              swipeable={false}
              infiniteLoop={true}
              onClickItem={this.onClickItem}
              showArrows={false}
              showStatus={false}
              showIndicators={false}
              showThumbs={false}
              selectedItem={currentIndex}
              className="Project-carousel"
            >
              {this.renderImages(images)}
            </Carousel>
          </div>
        </div>
        {isZoomed &&(
          <div onClick={this.onClickItem} className="Project-close-button">
            <svg width="35" height="35" viewBox="0 0 35 35">
              <rect x="16" width="3" height="35" transform="translate(-7.2487 17.5) rotate(-45)"/>
              <rect x="16" width="3" height="35" transform="translate(17.5 -7.2487) rotate(45)"/>
            </svg>
          </div>
        )}
      </div>
    )
  }
}

export default Project;



// WEBPACK FOOTER //
// ./src/components/galleryItems/Project/Project.js